import { AbstractEncoder2gxtu3xmy3f8j as AbstractEncoder } from '../encoding/AbstractEncoder.mjs';
import { EmptySerializersModule991ju6pz9b79 as EmptySerializersModule } from '../modules/SerializersModuleBuilders.mjs';
import { Unit_instance3kz1zqli6gr1r as Unit_instance } from '../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
var NoOpEncoderClass;
function NoOpEncoder() {
  if (NoOpEncoderClass === VOID) {
    class $ extends AbstractEncoder() {
      constructor() {
        return new.target.new_kotlinx_serialization_internal_NoOpEncoder_oemfqm_k$();
      }
      static new_kotlinx_serialization_internal_NoOpEncoder_oemfqm_k$() {
        NoOpEncoder_instance = null;
        var $this = this.new_kotlinx_serialization_encoding_AbstractEncoder_5rmec_k$();
        NoOpEncoder_instance = $this;
        $this.serializersModule_1 = EmptySerializersModule();
        return $this;
      }
      get_serializersModule_piitvg_k$() {
        return this.serializersModule_1;
      }
      encodeValue_g68i1f_k$(value) {
        return Unit_instance;
      }
      encodeNull_ejiosz_k$() {
        return Unit_instance;
      }
      encodeBoolean_tu2e59_k$(value) {
        return Unit_instance;
      }
      encodeByte_6txfee_k$(value) {
        return Unit_instance;
      }
      encodeShort_gza6si_k$(value) {
        return Unit_instance;
      }
      encodeInt_y5zi3z_k$(value) {
        return Unit_instance;
      }
      encodeLong_vlw3uq_k$(value) {
        return Unit_instance;
      }
      encodeFloat_b8b85a_k$(value) {
        return Unit_instance;
      }
      encodeDouble_n270q9_k$(value) {
        return Unit_instance;
      }
      encodeChar_id8ngf_k$(value) {
        return Unit_instance;
      }
      encodeString_424b5v_k$(value) {
        return Unit_instance;
      }
      encodeEnum_2qin0y_k$(enumDescriptor, index) {
        return Unit_instance;
      }
    }
    initMetadataForObject($, 'NoOpEncoder');
    NoOpEncoderClass = $;
  }
  return NoOpEncoderClass;
}
var NoOpEncoder_instance;
function NoOpEncoder_getInstance() {
  if (NoOpEncoder_instance === VOID)
    NoOpEncoder().new_kotlinx_serialization_internal_NoOpEncoder_oemfqm_k$();
  return NoOpEncoder_instance;
}
//region block: exports
export {
  NoOpEncoder_getInstance as NoOpEncoder_getInstanceajja35qtb1df,
};
//endregion

//# sourceMappingURL=NoOpEncoder.mjs.map
